import { FC } from "react";
import { Control, useController } from "react-hook-form";
import styled, { css } from "styled-components";
import Slider from "rc-slider";
import { HandlesProps } from "rc-slider/lib/Handles";
import "rc-slider/assets/index.css";

import { FormDataT } from "./ExtractorForm";

const StyledSlider = styled(Slider)`
  ${({ theme }) => css`
    margin: 30px 0;
    .rc-slider-rail {
      border-radius: 0;
      background-color: ${theme.colors.grayscale};
      left: 0;
    }
    .rc-slider-track {
      background-color: ${theme.colors.purpleLighter};
      border-radius: 0;
    }
  `}
`;

const Wrap = styled.div`
  padding: 0 12px;
`;

const Handle = styled.div`
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.purpleLighter};
  border-radius: 8px;
  border: 0;
  box-shadow: none !important;
  top: 0;
  opacity: 1;
  &.rc-slider-handle-2 {
    svg {
      transform: rotate(180deg);
    }
  }
`;

interface Props {
  control: Control<FormDataT>;
  maxValue: number;
}

const DurationSlider: FC<Props> = ({ control, maxValue }) => {
  const {
    field: { onChange: onChangeFrom, value: fromValue },
  } = useController<FormDataT>({
    control,
    name: "time_from",
  });

  const {
    field: { onChange: onChangeTo, value: toValue },
  } = useController<FormDataT>({
    control,
    name: "time_to",
  });

  const handleRender: HandlesProps["handleRender"] = ({ props }) => {
    return (
      <Handle {...props}>
        <svg
          width="5"
          height="8"
          viewBox="0 0 5 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 4L5 8V0L0 4Z" fill="currentColor" />
        </svg>
      </Handle>
    );
  };

  const onChange = (value: number | number[]) => {
    const values = value as number[];

    onChangeFrom(values[0]);
    onChangeTo(values[1]);
  };

  return (
    <Wrap>
      <StyledSlider
        range
        value={[fromValue as number, toValue as number]}
        onChange={onChange}
        max={maxValue}
        allowCross={false}
        handleRender={handleRender}
      />
    </Wrap>
  );
};

export default DurationSlider;
